export function formatDate(ts: number | null): string {
  if (!ts) return '';
  return new Date(ts * 1000).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatReadingTime(minutes: number | null): string {
  if (!minutes) return '';
  return `${minutes} min read`;
}

export function imageUrl(pathOrUrl: string, cdnBase = ''): string {
  if (!pathOrUrl) return '';
  if (/^https?:\/\//.test(pathOrUrl)) return pathOrUrl;
  // Normalize only the join boundary — collapsing `//` inside the path would
  // corrupt keys that legitimately contain empty segments.
  return `${cdnBase.replace(/\/+$/, '')}/${pathOrUrl.replace(/^\/+/, '')}`;
}

export const RESPONSIVE_WIDTHS = [400, 800, 1600] as const;

/**
 * srcset descriptor for images served through the worker's /img route, which
 * supports `?w=` resizing via Cloudflare image transforms. Returns undefined
 * for external URLs — the transform only applies to our own route.
 */
export function srcsetFor(pathOrUrl: string, cdnBase = ''): string | undefined {
  const url = imageUrl(pathOrUrl, cdnBase);
  if (!url || !url.includes('/img/')) return undefined;
  const sep = url.includes('?') ? '&' : '?';
  return RESPONSIVE_WIDTHS.map((w) => `${url}${sep}w=${w} ${w}w`).join(', ');
}

export function cx(...classes: (string | false | null | undefined)[]): string {
  return classes.filter(Boolean).join(' ');
}
